import { WALK_TYPE_ID_BOARDING, WALK_TYPE_ID_DROP_INS, WALK_TYPE_ID_HEALTH, WALK_TYPE_ID_SITTING, WALK_TYPE_ID_TRAINING, WALK_TYPE_ID_WALK } from "./walkTypes";
export const preferredServiceDeeplink = {
  [WALK_TYPE_ID_WALK]: 'dlwag://book',
  [WALK_TYPE_ID_SITTING]: 'dlwag://sitting',
  [WALK_TYPE_ID_BOARDING]: 'dlwag://sitting',
  [WALK_TYPE_ID_DROP_INS]: 'dlwag://drop-in',
  [WALK_TYPE_ID_TRAINING]: 'dlwag://training',
  [WALK_TYPE_ID_HEALTH]: 'dlwag://vet'
};